// 🇨🇿 Kompletní česká lokalizace pro Invoice Factory
export const czechTranslations = {
  // 🏠 Navigace a menu
  navigation: {
    dashboard: 'Přehled',
    invoices: 'Faktury',
    archive: 'Archiv',
    aboFiles: 'Platební soubory',
    users: 'Uživatelé',
    profile: 'Profil',
    settings: 'Nastavení',
    isdocMapping: 'ISDOC mapování',
    logout: 'Odhlásit se',
    backToHome: 'Zpět na hlavní stránku',
  },

  // 🏠 Dashboard
  dashboard: {
    title: 'Přehled systému',
    welcome: (name: string) => `Vítejte zpět, ${name}! 👋`,
    subtitle: 'Zde je přehled vašich faktur a platebních souborů',
    quickActions: 'Rychlé akce',
    createInvoice: '✨ Vytvořit fakturu',
    generateAbo: '💳 Vytvořit platební soubor',
    viewReports: '📊 Zobrazit reporty',
    
    stats: {
      totalInvoices: 'Celkem faktur',
      paidInvoices: 'Zaplacené faktury',
      pendingInvoices: 'Čekající faktury',
      totalAmount: 'Celková částka',
      thisMonth: 'Tento měsíc',
      growth: 'Růst',
      compared: 'oproti minulému měsíci',
    },
    
    recentActivity: {
      title: 'Nedávná aktivita',
      recentInvoices: 'Nedávné faktury',
      recentAboFiles: 'Nedávné platební soubory',
      viewAll: 'Zobrazit vše',
      noActivity: '🌟 Zatím žádná aktivita',
      startWorking: 'Začněte vytvářením nové faktury!',
    },
  },

  // 📄 Faktury
  invoices: {
    title: 'Správa faktur',
    subtitle: 'Spravujte všechny vaše faktury na jednom místě',
    createNew: '➕ Vytvořit novou fakturu',
    
    // Tabulka/seznam
    table: {
      invoiceNumber: 'Číslo faktury',
      supplier: 'Dodavatel',
      customer: 'Odběratel',
      amount: 'Částka',
      status: 'Stav',
      dueDate: 'Datum splatnosti',
      created: 'Vytvořeno',
      actions: 'Akce',
    },
    
    // Stavy
    status: {
      new: 'Nový',
      draft: 'Koncept',
      pending: 'Čeká na zpracování',
      reviewed: 'Zkontrolováno',
      ready_for_payment: 'Připraveno k platbě',
      sent_to_bank: 'Odesláno do banky',
      paid: 'Zaplaceno',
      paid_in_cash: 'Zaplaceno v hotovosti',
      rejected: 'Zamítnuto',
      cancelled: 'Zrušeno',
      archived: 'Archivováno',
    },
    internalNotes: {
      title: 'Interní poznámka',
      titleWithNumber: 'Interní poznámka - Faktura {number}',
      placeholder: 'Zde můžete zapsat interní poznámku k této faktuře...',
      addTooltip: 'Přidat interní poznámku',
      viewTooltip: 'Zobrazit/upravit poznámku',
      save: 'Uložit',
      cancel: 'Zrušit',
      empty: 'Žádná poznámka',
      ocrNotes: 'Poznámky z OCR (pouze pro čtení)',
      internalNotesLabel: 'Interní poznámky',
      characterCount: '{count} znaků',
      updated: 'Poznámka byla úspěšně uložena',
      updateFailed: 'Nepodařilo se uložit poznámku'
    },
    
    // Filtry
    filters: {
      search: 'Hledat faktury...',
      searchPlaceholder: 'Číslo faktury, dodavatel, odběratel...',
      status: 'Filtrovat podle stavu',
      allStatuses: 'Všechny stavy',
      dateFrom: 'Od',
      dateTo: 'Do',
      clearFilters: '🧹 Vymazat filtry',
    },
    
    // Akce
    actions: {
      view: 'Zobrazit',
      edit: 'Upravit',
      delete: 'Smazat',
      download: 'Stáhnout',
      downloadPdf: 'Stáhnout PDF',
      downloadIsdoc: 'Stáhnout ISDOC',
      bulkDelete: 'Smazat vybrané',
      selectAll: 'Vybrat vše',
      deselectAll: 'Zrušit výběr',
      markAsPaid: 'Označit jako zaplaceno',
      sendToBank: 'Odeslat do banky',
      archive: 'Archivovat',
      unarchive: 'Obnovit z archivu',
      bulkArchive: 'Archivovat vybrané',
      bulkUnarchive: 'Obnovit vybrané',
    },
    
    // Detail faktury
    detail: {
      title: 'Detail faktury',
      basicInfo: 'Základní informace',
      supplierInfo: 'Údaje dodavatele',
      customerInfo: 'Údaje odběratele',
      items: 'Položky faktury',
      summary: 'Rekapitulace',
      pdfPreview: 'PDF náhled',
      
      fields: {
        invoiceNumber: 'Číslo faktury',
        issueDate: 'Datum vystavení',
        dueDate: 'Datum splatnosti',
        supplierName: 'Název dodavatele',
        supplierAddress: 'Adresa dodavatele',
        supplierIco: 'IČO',
        supplierDic: 'DIČ',
        customerName: 'Název odběratele',
        customerAddress: 'Adresa odběratele',
        customerIco: 'IČO',
        customerDic: 'DIČ',
        description: 'Popis',
        quantity: 'Množství',
        unitPrice: 'Jednotková cena',
        totalPrice: 'Celková cena',
        vatRate: 'Sazba DPH',
        vatAmount: 'DPH',
        netAmount: 'Základ DPH',
        totalAmount: 'Celkem k úhradě',
      },
    },
    
    // Zprávy
    messages: {
      noInvoices: '📄 Zatím žádné faktury',
      createFirstInvoice: 'Vytvořte svou první fakturu a začněte!',
      deleteSuccess: '✅ Faktura byla úspěšně smazána',
      deleteError: '❌ Chyba při mazání faktury',
      bulkDeleteSuccess: (count: number) => `✅ Úspěšně smazáno ${count} faktur`,
      bulkDeleteError: '❌ Chyba při hromadném mazání faktur',
      loadingInvoices: '⏳ Načítám faktury...',
      archiveSuccess: '✅ Faktura byla úspěšně archivována',
      archiveError: '❌ Chyba při archivaci faktury',
      unarchiveSuccess: '✅ Faktura byla úspěšně obnovena z archivu',
      unarchiveError: '❌ Chyba při obnovení faktury z archivu',
      bulkArchiveSuccess: (count: number) => `✅ Úspěšně archivováno ${count} faktur`,
      bulkArchiveError: '❌ Chyba při hromadné archivaci faktur',
      bulkUnarchiveSuccess: (count: number) => `✅ Úspěšně obnoveno ${count} faktur z archivu`,
      bulkUnarchiveError: '❌ Chyba při hromadném obnovení faktur z archivu',
      noArchivedInvoices: '📦 Zatím žádné archivované faktury',
      
      confirmDelete: {
        title: '🗑️ Smazat fakturu?',
        message: 'Opravdu chcete smazat tuto fakturu? Tato akce je nevratná.',
        confirm: 'Ano, smazat',
        cancel: 'Zrušit',
      },
      
      confirmBulkDelete: {
        title: '🗑️ Smazat vybrané faktury?',
        message: (count: number) => `Opravdu chcete smazat ${count} vybraných faktur? Tato akce je nevratná.`,
        confirm: 'Ano, smazat vše',
        cancel: 'Zrušit',
      },
      
      confirmArchive: {
        title: '📦 Archivovat fakturu?',
        message: 'Opravdu chcete archivovat tuto fakturu? Můžete ji později obnovit.',
        confirm: 'Ano, archivovat',
        cancel: 'Zrušit',
      },
      
      confirmBulkArchive: {
        title: '📦 Archivovat vybrané faktury?',
        message: (count: number) => `Opravdu chcete archivovat ${count} vybraných faktur?`,
        confirm: 'Ano, archivovat vše',
        cancel: 'Zrušit',
      },
    },
  },

  // 💳 ABO soubory
  abo: {
    title: 'Platební soubory ABO',
    subtitle: 'Správa platebních souborů pro banky',
    createNew: '➕ Vytvořit nový soubor',
    
    table: {
      fileName: 'Název souboru',
      bankType: 'Typ banky',
      totalAmount: 'Celková částka',
      transactionCount: 'Počet transakcí',
      status: 'Stav',
      created: 'Vytvořeno',
      actions: 'Akce',
    },
    
    status: {
      generated: 'Vytvořeno',
      sent: 'Odesláno',
      sent_to_fio: 'Odesláno do FIO',
      error: 'Chyba',
      processing: 'Zpracovávám...',
    },
    
    actions: {
      view: 'Zobrazit detail',
      download: 'Stáhnout soubor',
      sendToBank: 'Odeslat do banky',
      delete: 'Smazat',
      regenerate: 'Vygenerovat znovu',
    },
    
    fioApi: {
      pastPaymentsAdjusted: 'platba(y) s minulým datem splatnosti byla(y) upravena(y) na dnešní datum pro FIO API.',
      sendSuccess: 'Soubor byl úspěšně odeslán do FIO API',
      sendError: 'Chyba při odesílání do FIO API',
      getBankAccountsError: 'Chyba při získávání bankovních účtů z FIO',
      invalidResponse: 'Neplatná odpověď ze serveru',
    },
    
    filters: {
      search: 'Hledat soubory...',
      bankType: 'Filtrovat podle banky',
      allBanks: 'Všechny banky',
      dateFrom: 'Od',
      dateTo: 'Do',
    },
    
    generate: {
      title: '💫 Vytvořit nový platební soubor',
      selectInvoices: 'Vyberte faktury k platbě',
      bankAccount: 'Vyberte bankovní účet',
      selectedInvoices: (count: number) => `Vybrané faktury (${count})`,
      totalAmount: 'Celková částka',
      generate: 'Vygenerovat soubor',
      cancel: 'Zrušit',
      noInvoices: '📋 Žádné faktury připravené k platbě',
      loadingInvoices: '⏳ Načítám připravené faktury...',
    },
    
    messages: {
      noFiles: '📁 Zatím žádné platební soubory',
      createFirst: 'Vytvořte svůj první platební soubor!',
      generateSuccess: '✅ Platební soubor byl úspěšně vytvořen',
      generateError: '❌ Chyba při vytváření platebního souboru',
      deleteSuccess: '✅ Soubor byl úspěšně smazán',
      deleteError: '❌ Chyba při mazání souboru',
      sendSuccess: '✅ Soubor byl úspěšně odeslán do banky',
      sendError: '❌ Chyba při odesílání do banky',
    },
  },

  // 👥 Uživatelé
  users: {
    title: 'Správa uživatelů',
    subtitle: 'Spravujte uživatele a jejich oprávnění',
    createNew: '➕ Přidat nového uživatele',
    
    table: {
      name: 'Jméno',
      email: 'Email',
      role: 'Role',
      status: 'Stav',
      created: 'Vytvořeno',
      lastLogin: 'Poslední přihlášení',
      actions: 'Akce',
    },
    
    roles: {
      admin: 'Administrátor',
      user: 'Uživatel',
      superadmin: 'Super administrátor',
    },
    
    status: {
      active: 'Aktivní',
      inactive: 'Neaktivní',
      pending: 'Čeká na aktivaci',
    },
    
    actions: {
      view: 'Zobrazit profil',
      edit: 'Upravit',
      delete: 'Smazat',
      resetPassword: 'Resetovat heslo',
      activate: 'Aktivovat',
      deactivate: 'Deaktivovat',
    },
    
    filters: {
      search: 'Hledat uživatele...',
      role: 'Filtrovat podle role',
      allRoles: 'Všechny role',
      status: 'Filtrovat podle stavu',
      allStatuses: 'Všechny stavy',
    },
    
    messages: {
      noUsers: '👥 Žádní uživatelé',
      deleteSuccess: '✅ Uživatel byl úspěšně smazán',
      deleteError: '❌ Chyba při mazání uživatele',
      resetPasswordSuccess: '✅ Heslo bylo úspěšně resetováno',
      resetPasswordError: '❌ Chyba při resetování hesla',
      
      confirmDelete: {
        title: '🗑️ Smazat uživatele?',
        message: 'Opravdu chcete smazat tohoto uživatele? Tato akce je nevratná.',
        confirm: 'Ano, smazat',
        cancel: 'Zrušit',
      },
    },
  },

  // 👤 Profil
  profile: {
    title: 'Můj profil',
    subtitle: 'Spravujte své osobní údaje a nastavení',
    
    sections: {
      basicInfo: 'Základní informace',
      security: 'Zabezpečení',
      bankAccounts: 'Bankovní účty',
      activity: 'Aktivita',
      preferences: 'Předvolby',
    },
    
    basicInfo: {
      firstName: 'Křestní jméno',
      lastName: 'Příjmení',
      email: 'Email',
      phone: 'Telefon',
      organizationName: 'Název organizace',
      organizationAddress: 'Adresa organizace',
      ico: 'IČO',
      dic: 'DIČ',
      edit: 'Upravit profil',
      save: 'Uložit změny',
      cancel: 'Zrušit',
    },
    
    security: {
      changePassword: 'Změnit heslo',
      currentPassword: 'Současné heslo',
      newPassword: 'Nové heslo',
      confirmPassword: 'Potvrdit heslo',
      save: 'Změnit heslo',
      cancel: 'Zrušit',
    },
    
    bankAccounts: {
      title: 'Bankovní účty',
      add: 'Přidat účet',
      accountName: 'Název účtu',
      accountNumber: 'Číslo účtu',
      bankCode: 'Kód banky',
      iban: 'IBAN',
      swift: 'SWIFT',
      delete: 'Smazat účet',
    },
    
    messages: {
      updateSuccess: '✅ Profil byl úspěšně aktualizován',
      updateError: '❌ Chyba při aktualizaci profilu',
      passwordChangeSuccess: '✅ Heslo bylo úspěšně změněno',
      passwordChangeError: '❌ Chyba při změně hesla',
      bankAccountAddSuccess: '✅ Bankovní účet byl přidán',
      bankAccountDeleteSuccess: '✅ Bankovní účet byl smazán',
    },
  },

  // 🔐 Autentizace
  auth: {
    login: {
      title: '🔐 Přihlášení',
      subtitle: 'Přihlaste se do vašeho účtu',
      email: 'Email',
      password: 'Heslo',
      rememberMe: 'Zapamatovat si mě',
      forgotPassword: 'Zapomněli jste heslo?',
      loginButton: 'Přihlásit se',
      noAccount: 'Nemáte účet?',
      register: 'Zaregistrovat se',
      
      errors: {
        invalidCredentials: '❌ Neplatné přihlašovací údaje',
        emailRequired: 'Email je povinný',
        passwordRequired: 'Heslo je povinné',
      },
    },
    
    forgotPassword: {
      title: '🔑 Zapomenuté heslo',
      subtitle: 'Zadejte svůj email a my vám pošleme odkaz pro obnovení hesla',
      email: 'Váš email',
      sendButton: 'Odeslat odkaz pro obnovení',
      backToLogin: 'Zpět na přihlášení',
      
      success: {
        title: '✅ Email odeslán!',
        message: 'Pokud existuje účet s touto emailovou adresou, odeslali jsme vám odkaz pro obnovení hesla.',
        instruction: 'Zkontrolujte svou emailovou schránku a postupujte podle instrukcí.',
        resend: 'Neobdrželi jste email? Odeslat znovu',
      },
      
      errors: {
        emailRequired: 'Email je povinný',
        invalidEmail: 'Neplatný formát emailu',
        serverError: 'Chyba serveru. Zkuste to prosím znovu.',
        tooManyRequests: 'Příliš mnoho požadavků. Zkuste to znovu za chvíli.',
      },
    },
    
    resetPassword: {
      title: '🆕 Nové heslo',
      subtitle: 'Zadejte své nové heslo',
      newPassword: 'Nové heslo',
      confirmPassword: 'Potvrdit nové heslo',
      resetButton: 'Nastavit nové heslo',
      backToLogin: 'Zpět na přihlášení',
      
      success: {
        title: '🎉 Heslo úspěšně změněno!',
        message: 'Vaše heslo bylo úspěšně aktualizováno.',
        instruction: 'Nyní se můžete přihlásit s novým heslem.',
        loginButton: 'Přejít na přihlášení',
      },
      
      errors: {
        passwordRequired: 'Heslo je povinné',
        passwordMismatch: 'Hesla se neshodují',
        weakPassword: 'Heslo musí mít alespoň 8 znaků',
        invalidToken: 'Neplatný nebo vypršelý odkaz pro obnovení',
        serverError: 'Chyba serveru. Zkuste to prosím znovu.',
      },
    },
    
    register: {
      title: '📝 Registrace',
      subtitle: 'Vytvořte si nový účet',
      firstName: 'Křestní jméno',
      lastName: 'Příjmení',
      email: 'Email',
      password: 'Heslo',
      confirmPassword: 'Potvrdit heslo',
      organizationName: 'Název organizace',
      registerButton: 'Zaregistrovat se',
      hasAccount: 'Už máte účet?',
      login: 'Přihlásit se',
      
      errors: {
        passwordMismatch: 'Hesla se neshodují',
        emailExists: 'Email už je používán',
        weakPassword: 'Heslo je příliš slabé',
      },
    },
    
    logout: {
      title: '👋 Odhlášení',
      message: 'Opravdu se chcete odhlásit?',
      confirm: 'Ano, odhlásit',
      cancel: 'Zrušit',
    },
  },

  // 🎨 Obecné komponenty
  common: {
    // Tlačítka
    buttons: {
      save: 'Uložit',
      cancel: 'Zrušit',
      delete: 'Smazat',
      edit: 'Upravit',
      view: 'Zobrazit',
      download: 'Stáhnout',
      upload: 'Nahrát',
      back: 'Zpět',
      next: 'Další',
      previous: 'Předchozí',
      close: 'Zavřít',
      open: 'Otevřít',
      refresh: 'Obnovit',
      search: 'Hledat',
      filter: 'Filtrovat',
      export: 'Exportovat',
      import: 'Importovat',
      send: 'Odeslat',
      submit: 'Odeslat',
      confirm: 'Potvrdit',
      retry: 'Zkusit znovu',
    },
    
    // Stavy načítání
    loading: {
      default: '⏳ Načítám...',
      saving: '💾 Ukládám...',
      deleting: '🗑️ Mažu...',
      uploading: '📤 Nahrávám...',
      downloading: '📥 Stahuji...',
      sending: '📧 Odesílám...',
      processing: '⚙️ Zpracovávám...',
      connecting: '🔗 Připojuji...',
    },
    
    // Chybové zprávy
    errors: {
      general: '❌ Něco se pokazilo',
      network: '🌐 Chyba sítě',
      serverError: '🚫 Chyba serveru',
      notFound: '🔍 Nenalezeno',
      unauthorized: '🔐 Nemáte oprávnění',
      forbidden: '⛔ Přístup zamítnut',
      timeout: '⏰ Časový limit vypršel',
      tryAgain: 'Zkuste to prosím znovu',
      contactSupport: 'Kontaktujte podporu',
    },
    
    // Úspěšné zprávy
    success: {
      saved: '✅ Úspěšně uloženo',
      deleted: '✅ Úspěšně smazáno',
      sent: '✅ Úspěšně odesláno',
      uploaded: '✅ Úspěšně nahráno',
      downloaded: '✅ Úspěšně staženo',
      updated: '✅ Úspěšně aktualizováno',
      created: '✅ Úspěšně vytvořeno',
    },
    
    // Datum a čas
    dateTime: {
      today: 'Dnes',
      yesterday: 'Včera',
      tomorrow: 'Zítra',
      thisWeek: 'Tento týden',
      thisMonth: 'Tento měsíc',
      thisYear: 'Tento rok',
      selectDate: 'Vyberte datum',
      selectTime: 'Vyberte čas',
    },
    
    // Validace
    validation: {
      required: 'Toto pole je povinné',
      email: 'Neplatný formát emailu',
      minLength: (min: number) => `Minimálně ${min} znaků`,
      maxLength: (max: number) => `Maximálně ${max} znaků`,
      numeric: 'Pouze čísla',
      positive: 'Musí být kladné číslo',
      phoneNumber: 'Neplatné telefonní číslo',
      url: 'Neplatná URL adresa',
    },
    
    // Prázdné stavy
    empty: {
      noData: '📭 Žádná data',
      noResults: '🔍 Žádné výsledky',
      noItems: '📦 Žádné položky',
      startHere: 'Začněte zde',
      getStarted: 'Začít',
    },
    
    // Páginace
    pagination: {
      page: 'Stránka',
      of: 'z',
      rowsPerPage: 'Řádků na stránku',
      first: 'První',
      last: 'Poslední',
      next: 'Další',
      previous: 'Předchozí',
    },
    
    // Potvrzovací dialogy
    confirmDialog: {
      title: 'Potvrdit akci',
      message: 'Opravdu chcete pokračovat?',
      yes: 'Ano',
      no: 'Ne',
      ok: 'OK',
      cancel: 'Zrušit',
    },
  },

  // 🎯 ISDOC mapování
  isdoc: {
    title: 'ISDOC mapování',
    subtitle: 'Nástroj pro mapování a konverzi ISDOC dokumentů',
    upload: 'Nahrát ISDOC soubor',
    process: 'Zpracovat',
    download: 'Stáhnout výsledek',
    
    status: {
      ready: 'Připraven',
      processing: 'Zpracovávám',
      completed: 'Dokončeno',
      error: 'Chyba',
    },
    
    messages: {
      uploadSuccess: '✅ ISDOC soubor byl úspěšně nahrán',
      processSuccess: '✅ Dokument byl úspěšně zpracován',
      downloadReady: '📥 Soubor je připraven ke stažení',
      error: '❌ Chyba při zpracování ISDOC',
    },
  },

  // 🔧 Nastavení
  settings: {
    title: 'Nastavení systému',
    subtitle: 'Konfigurace systému a předvolby',
    
    sections: {
      general: 'Obecné',
      invoicing: 'Fakturace',
      payments: 'Platby',
      notifications: 'Notifikace',
      security: 'Zabezpečení',
      integrations: 'Integrace',
    },
    
    messages: {
      saveSuccess: '✅ Nastavení bylo úspěšně uloženo',
      saveError: '❌ Chyba při ukládání nastavení',
    },
    },
  
  // ⚠️ Systémové zprávy a alerty
  alerts: {
    downloadError: 'Chyba při stahování souboru',
    deleteError: 'Chyba při mazání',
    deleteAboError: 'Chyba při mazání ABO souboru',
    deleteInvoicesError: 'Chyba při mazání faktur',
    sendToFioError: 'Chyba při odesílání do FIO API',
    downloadFailed: 'Stažení souboru se nezdařilo',
    pdfNotFound: 'PDF soubor nebyl nalezen pro tuto fakturu',
    pdfDownloadError: 'Chyba při stahování PDF souboru',
    cannotDeleteOwnAccount: 'Nemůžete smazat svůj vlastní účet',
    unknownError: 'Neznámá chyba',
    
    // FIO API zprávy
    fioSuccess: (message: string) => `✅ ${message}`,
    fioError: (error: string) => `❌ FIO API Chyba: ${error}`,
    fioSendFailed: '❌ Chyba: Nepodařilo se odeslat do FIO API',
    fioBankAccountsFailed: '❌ Chyba: Nepodařilo se získat FIO bankovní účty',
    paymentsSentToFioSuccessfully: 'Platby byly úspěšně odeslány do FIO',
    
    // Úspěchy
    success: (message: string) => `✅ ${message}`,
    error: (message: string) => `❌ Chyba: ${message}`,
    warning: (message: string) => `⚠️ Poznámka: ${message}`,
  },
  
  // 🎉 Motivační zprávy
  motivation: {
    wellDone: '🎉 Skvělá práce!',
    keepGoing: '💪 Pokračujte!',
    almostThere: '🏁 Už to skoro máte!',
    excellent: '⭐ Výborně!',
    congratulations: '🎊 Gratulujeme!',
    amazing: '🤩 Úžasné!',
    fantastic: '🌟 Fantastické!',
    perfect: '✨ Perfektní!',
    awesome: '🚀 Báječné!',
    brilliant: '💎 Brilantní!',
  },

  // 📱 Mobilní specifické
  mobile: {
    pullToRefresh: '⬇️ Táhněte pro obnovení',
    releaseToRefresh: '⬆️ Pusťte pro obnovení',
    refreshing: '🔄 Obnovuji...',
    swipeLeft: '⬅️ Přejeďte vlevo',
    swipeRight: '➡️ Přejeďte vpravo',
    tapToView: '👆 Klepněte pro zobrazení',
    longPressForOptions: '👆 Podržte pro možnosti',
    backToTop: '⬆️ Zpět nahoru',
  },
};

export default czechTranslations;
